@import "./sellalong-panel-purchase-item.css";
.sellalong-panel-purchase-item-select-cta:hover {
  background: var(--sellalong-colour-primary, #000);
  border-color: var(--sellalong-colour-primary, #000);
  color: #fff;
}

:host.sellalong-panel-purchase-item-state-tosell
  .sellalong-panel-purchase-item-select-cta:hover {
  background: var(--sellalong-colour-primary-tint, #333);
  border-color: var(--sellalong-colour-primary-tint, #333);
  color: #fff;
}
